import React, { useState } from "react";
import "../../CSS/Ninder.css";

const Ninder = () => {
  const [cardStyles, setCardStyles] = useState({});
  const [cardContent, setCardContent] = useState(
    <img src="../images/Me-4.png" alt="Profile" />
  );

  const [startX, setStartX] = useState(null);

  function ClickFunc() {
    window.location.href = "http://nicholasradstake.com";
  }

  // Touch handlers (mobile)
  const handleTouchStart = (e) => {
    const touchX = e.touches[0].clientX;
    setStartX(touchX);
  };

  const handleTouchMove = (e) => {
    if (startX == null) return;
    const touchX = e.touches[0].clientX;
    const deltaX = touchX - startX;

    setCardStyles({
      transform: `translateX(${deltaX}px) rotate(${deltaX / 20}deg)`,
      transition: "none",
    });
  };

  const handleTouchEnd = (e) => {
    if (startX == null) return;

    const endX = e.changedTouches[0].clientX;
    const deltaX = endX - startX;
    const threshold = 80;

    // Swipe left
    if (deltaX < -threshold) {
      setCardStyles({
        transform: "translateX(-120vw) rotate(-25deg)",
        transition: "transform 0.25s ease-out",
      });

      setTimeout(() => {
        setCardStyles({ transform: "translateX(0)", transition: "none" });
        setCardContent(
          <div id="Reject">
            <p>Nope – you can’t actually swipe left here 😅</p>
          </div>
        );
      }, 260);
    }
    // Swipe right
    else if (deltaX > threshold) {
      setCardStyles({
        transform: "translateX(120vw) rotate(25deg)",
        transition: "transform 0.25s ease-out",
      });

      setTimeout(() => {
        setCardStyles({ transform: "translateX(0)", transition: "none" });
        setCardContent(
          <div id="Match">
            <p>It’s a match. Text me: +1 (248) 382-8520</p>
          </div>
        );
      }, 260);
    }
    // Not enough movement – snap back
    else {
      setCardStyles({
        transform: "translateX(0) rotate(0deg)",
        transition: "transform 0.2s ease-out",
      });
    }

    setStartX(null);
  };

  const header = (
    <div className="Header--Container">
      <img src="../images/tinder.png" onClick={ClickFunc} alt="Tinder logo" />
      <p className="Header--text">Ninder</p>
    </div>
  );

  return (
    <div>
      {header}
      <p className="TinderTitle">
        Basically Tinder but it&apos;s just me and you can&apos;t swipe left
      </p>
      <div id="cardContainer">
        <div
          id="card"
          style={cardStyles}
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
          onTouchEnd={handleTouchEnd}
        >
          {cardContent}
          <div className="TinderButtons">
            <button aria-label="Nope">✕</button>
            <button aria-label="Like">❤</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Ninder;
